import { motion } from "framer-motion";

const diceFaces = {
  1: [[50, 50]],
  2: [[25, 25], [75, 75]],
  3: [[25, 25], [50, 50], [75, 75]],
  4: [[25, 25], [75, 25], [25, 75], [75, 75]],
  5: [[25, 25], [75, 25], [50, 50], [25, 75], [75, 75]],
  6: [[25, 25], [75, 25], [25, 50], [75, 50], [25, 75], [75, 75]],
};

function DiceFace({ value, size = 120, isRolling = false, className = "" }) {
  const dots = diceFaces[value] || diceFaces[1];
  const dotSize = size * 0.15;

  return (
    <motion.div
      className={`relative rounded-xl border-2 border-primary/30 ${className}`}
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #1a1a1f 0%, #0a0a0c 100%)",
        boxShadow: isRolling
          ? "0 0 30px rgba(8, 254, 148, 0.5), inset 0 0 20px rgba(8, 254, 148, 0.1)"
          : "0 0 20px rgba(8, 254, 148, 0.3), inset 0 0 10px rgba(8, 254, 148, 0.05)",
      }}
      animate={
        isRolling
          ? {
              rotateX: [0, 360, 720],
              rotateY: [0, 360, 720],
              scale: [1, 1.1, 1],
            }
          : {}
      }
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      {dots.map((pos, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full bg-primary"
          style={{
            width: dotSize,
            height: dotSize,
            left: `${pos[0]}%`,
            top: `${pos[1]}%`,
            transform: "translate(-50%, -50%)",
            boxShadow: "0 0 10px rgba(8, 254, 148, 0.8)",
          }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: isRolling ? 0.8 + i * 0.05 : 0, duration: 0.2 }}
        />
      ))}
    </motion.div>
  );
}

export default function Dice({ dice1, dice2, isRolling }) {
  return (
    <div className="flex items-center justify-center gap-6">
      <DiceFace value={dice1} isRolling={isRolling} />
      <div className="text-4xl font-heading text-muted-foreground">+</div>
      <DiceFace value={dice2} isRolling={isRolling} />
    </div>
  );
}

export { DiceFace };
